/* eslint-disable max-len */
import React, { Component } from 'react';
import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';

import { history } from '../routers/AppRouter';
import Table from '../components/table/table';
import TableRegisterButton from '../components/table/registerButton';
import ROUTES from '../data/routes';
import { getListProductFeedbackReason, updateProductFeedbackReason } from '../app/store/actions/productFeedbackReason';
import ModalComponent from '../components/modal';

class ProductFeedbackReason extends Component {
  constructor(props) {
    super(props);
    this.state = {
      limit: 20,
      page: 1,
      search: '',
      orderBy: 'ASC',
      field: 'productFeedbackReasonId',
      registrationList: [],
      totalRecord: 0,
      showModal: false,
      showCancel: false,
      titleModal: '',
      titleModalBody: '',
      selectedLine: {},
    };

    this.tableHeader = [
      { key: 'productFeedbackReasonId', value: I18n.t('idReason') },
      { key: 'reason', value: I18n.t('reason') },
      { key: 'status', value: I18n.t('status') },
      { key: 'action', value: I18n.t('action') },
    ];
  }

  getListProductFeedbackReason = async () => {
    const {
      search, page, limit, orderBy = '', field = '',
    } = this.state;
    const skip = (page - 1) * limit;

    try {
      const { count = 0, rows = [] } = await this.props.getListProductFeedbackReason(
        limit, skip, search, orderBy, field,
      );

      await this.adjustData(count, rows);
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('erroFetch')
        })
      }
    }
  }

  updateProductFeedbackReason = async (parameters = {}) => {
    try {
      await this.props.updateProductFeedbackReason({ ...parameters })

      await this.getListProductFeedbackReason();
    } catch (err) {
      const error = err.response && err.response.data && err.response.data.error
      if (error && error.message) {
        const messageError = (error.code && error.details) ?
          `${error.code} - ${error.details} | ${error.message}`
          : error.message;

        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: messageError
        })
      } else {
        this.setState({
          showModal: true,
          showCancel: false,
          titleModal: I18n.t('Error'),
          titleModalBody: I18n.t('errorOcurred')
        })
      }
    }
  }

  adjustData = async (count = 0, rows = []) => {
    const registrationList = rows.map(element => ({
      key: element.id,
      productFeedbackReasonId: element.id,
      reason: element.reason,
      status: (
        <div className="row margin-left-0">
          <button
            type="button"
            className={`btn btn-${element.status ? 'warning' : 'dark'} promotion-btn-${element.status ? 'warning' : 'active'}`}
            onClick={() => this.updateProductFeedbackReason({ productFeedbackReasonId: element.id, status: !element.status })}
          >
            {(element.status)
              ? I18n.t('disable')
              : I18n.t('active')
            }
          </button>
        </div>
      ),
      action: (
        <div className="btn-group" role="group" aria-label="Button group with nested dropdown">
          <div className="btn-group" role="group">
            <button
              id="btnGroupDrop1"
              type="button"
              className="btn btn-secondary dropdown-toggle"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
            >
              {I18n.t('action')}
            </button>
            <div className="dropdown-menu" aria-labelledby="btnGroupDrop1">
              <button
                type="button"
                className="dropdown-item dropdown-table"
                onClick={() => {
                  (element.status)
                    ? history.push({
                      pathname: ROUTES.FORM,
                      screenComming: 'productFeedbackReason',
                      selectedProductFeedbackReason: element,
                    })
                    : this.setState({
                      showModal: true,
                      showCancel: false,
                      titleModal: I18n.t('disabledRecord'),
                      titleModalBody: I18n.t('noticeToProductFeedbackReason')
                    })
                }}
              >
                {I18n.t('edit')}
              </button>
            </div>
          </div>
        </div>
      ),
    }));

    this.setState({
      totalRecord: count,
      registrationList,
    });
  }

  sortTable = async (field, orderBy) => {
    await this.setState({ orderBy, field });
    await this.getListProductFeedbackReason();
  }

  searchTable = async (search = '', page = 1) => {
    await this.setState({ search, page });
    await this.getListProductFeedbackReason();
  }

  tableButtons = () => (
    <React.Fragment>
      <TableRegisterButton route={{ pathname: ROUTES.FORM, screenComming: 'productFeedbackReason' }} />
    </React.Fragment>
  )

  componentDidMount() {
    this.getListProductFeedbackReason();
  }

  render() {
    const {
      limit, page, registrationList, totalRecord,
      titleModal, titleModalBody, showModal, showCancel,
    } = this.state;

    return (
      <div className="main-div-tables">
        <ModalComponent
          title={titleModal}
          showCancel={showCancel}
          body={titleModalBody}
          visible={showModal}
          closeModal={() => this.setState({ showModal: false })}
          titleOkButtoon={I18n.t('ok')}
          size={{ width: '350px', height: '200px' }}
          confirmModal={() => this.setState({ showModal: false })}
          showButtons
        />
        <Table
          title={I18n.t('productFeedbackReason')}
          buttons={this.tableButtons()}
          header={this.tableHeader}
          lines={registrationList}
          page={page}
          perPage={limit}
          count={totalRecord || 0}
          searchItems={this.searchTable}
          showItemsCount
          sortTable={this.sortTable}
        />
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getListProductFeedbackReason: (limit, skip, search, orderBy, field) => dispatch(getListProductFeedbackReason(limit, skip, search, orderBy, field)),
  updateProductFeedbackReason: (productFeedbackReasonParameter) => dispatch(updateProductFeedbackReason(productFeedbackReasonParameter)),
});

const mapStateToProps = state => ({
});

export default connect(mapStateToProps, mapDispatchToProps)(ProductFeedbackReason);
